import { FONT } from '@cuemath/comps';
import { getTheme } from '@cuemath/leap';

import COLORS from './colors';
import LAYOUT from './layout';
import { getWeight } from './weights';
import ZINDEX from './zindex';

const theme = {
  LAYOUT,
  ZINDEX,
  COLORS,
  FONT: {
    FAMILY: FONT.FAMILY,
    SIZES: {
      xsmall: 8,
      smaller: 10,
      small: 10,
      normal: 13,
      medium: 15,
      large: 18,
      larger: 18,
      xlarge: 22,
      xxlarge: 22,
      xxslarge: 30,
      xxxlarge: 38,
      largest: 60,
    },
    WEIGHTS: {
      bolder: 700,
      bold: 700,
      semibold: 600,
      medium: 500,
      normal: 500,
      light: 500,
      lighter: 400,
      thin: 400,
    },
  },
  TEXT: {
    PADDING: 4,
    COLORS: {
      normal: COLORS.GRAY,
      light: '#7B7B7B',
      lighter: '#BAC0C3',
      primary: '#0177FF',
      positive: COLORS.GRASS,
      negative: COLORS.HEART_DARK,
      white: COLORS.WHITE,
    },
  },
  BUTTON: {
    HEIGHTS: {
      normal: 40,
      compact: 32,
    },
    SPINNERS: {
      normal: 16,
      compact: 10,
    },
    PADDING: 16,
    RADIUS: 4,
  },
  BUTTONS: {
    'primary': {
      border: 0,
      background: 'linear-gradient(56.99deg, #0177FF 0%, #1F48D7 100%)',
      backgroundHover: 'linear-gradient(58.2deg, #0177FF 0%, #000000 100%)',
      backgroundDisabled: 'rgba(204, 220, 238, 0.5)',
      color: COLORS.WHITE,
      colorDisabled: COLORS.SKY_XLIGHT,
    },
    'secondary': {
      border: 0,
      background: 'rgba(182,192,195,0.8)',
      backgroundHover: 'rgba(182,192,195,0.8)',
      backgroundDisabled: 'gray',
      color: COLORS.GRAY,
      colorDisabled: COLORS.SKY_XLIGHT,
    },
    'inverted': {
      border: `1px solid ${COLORS.SKY_DARK}`,
      borderHover: `1px solid ${COLORS.SKY_DARK}`,
      borderDisabled: '1px solid #E6EEF7',
      background: 'transparent',
      color: COLORS.SKY_DARK,
      colorHover: COLORS.SKY_XDARK,
      colorDisabled: COLORS.SKY_XLIGHT,
    },
    'link': {
      border: 0,
      background: 'transparent',
      color: COLORS.SKY_DARK,
      colorHover: COLORS.SKY_XDARK,
      colorDisabled: COLORS.SKY_XLIGHT,
    },
    'link-sky': {
      border: 0,
      background: 'transparent',
      color: COLORS.SKY,
      colorDisabled: COLORS.SKY_XLIGHT,
    },
    'link-inverted': {
      border: 0,
      background: 'transparent',
      color: COLORS.WHITE,
      colorHover: COLORS.WHITE,
      colorDisabled: COLORS.WHITE,
    },
    'attempted': {
      border: 0,
      background: 'linear-gradient(56.99deg, #20aaca 0%, #16e6fb 100%)',
      backgroundHover: 'linear-gradient(56.99deg, #5bbad0 0%, #03a3b3 100%)',
      backgroundDisabled: 'rgba(204, 220, 238, 0.5)',
      color: COLORS.WHITE,
      colorDisabled: COLORS.SKY_XLIGHT,
    },
    'learnositySecondary': {
      border: `1px solid ${COLORS.GHOST}`,
      borderDisabled: `1px solid ${COLORS.GHOST}`,
      background: COLORS.WHITE,
      color: COLORS.SKY,
      radius: 28,
    },
    'learnosityPrimary': {
      border: `0px solid ${COLORS.PRIMARY}`,
      borderDisabled: `0px solid ${COLORS.PRIMARY}`,
      background: COLORS.SKY,
      color: COLORS.WHITE,
      radius: 28,
    },
  },
  PUSH_BUTTON: {
    primary: {
      border: 0,
      background: COLORS.PRIMARY,
      color: COLORS.SKY,
      labelColor: COLORS.WHITE,
    },
    danger: {
      border: 0,
      background: COLORS.HEART_DARK,
      color: COLORS.HEART,
      labelColor: COLORS.WHITE,
    },
    secondary: {
      border: 0,
      background: COLORS.SUN_DARK,
      color: COLORS.SUN,
      labelColor: COLORS.WHITE,
    },
  },
  CARD: {
    background: COLORS.WHITE,
    radius: 4,
    shadow: '0 0 4px 0 rgba(33, 92, 91, 0.31)',
  },
};

const getAppTheme = () => ({
  ...getWeight(theme),
  ...getTheme(),
});

export default getAppTheme;
